import { useState, useEffect } from "react";
import { Trophy } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PGALeaderboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/pga-leaderboard`).then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
    const interval = setInterval(() => {
      axios.get(`${API}/pga-leaderboard`).then((r) => setData(r.data)).catch(() => {});
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div className="space-y-2">{[...Array(10)].map((_, i) => <div key={i} className="h-12 bg-[#141414] rounded-lg animate-pulse" />)}</div>;
  if (!data || !data.event) return <div className="text-center py-12 text-white/30 text-sm">No tournament data available</div>;

  const { event, players } = data;
  const roundCount = players[0]?.rounds?.length || 4;

  return (
    <div className="space-y-4" data-testid="pga-leaderboard">
      {/* Tournament header */}
      <div className="bg-[#141414] border border-white/10 rounded-xl p-4">
        <div className="flex items-center gap-3">
          <Trophy size={20} weight="fill" className="text-[#34C759]" />
          <div>
            <h2 className="font-['Bebas_Neue'] text-xl sm:text-2xl uppercase tracking-wider text-white">{event.name}</h2>
            <div className="flex items-center gap-2 mt-0.5">
              <span className="text-xs text-white/40">{event.venue}</span>
              <span className="text-[10px] tracking-widest uppercase text-[#007AFF] font-bold">{event.status}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Leaderboard table */}
      <div className="bg-[#141414] border border-white/10 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-white/10 text-[9px] sm:text-[10px] tracking-widest uppercase text-white/40 font-bold">
                <th className="text-left px-3 py-2.5 w-10">Pos</th>
                <th className="text-left px-2 py-2.5">Player</th>
                <th className="text-center px-2 py-2.5 w-16 bg-white/5">Score</th>
                {[...Array(roundCount)].map((_, i) => (
                  <th key={i} className="text-center px-2 py-2.5 w-12 hidden sm:table-cell">R{i + 1}</th>
                ))}
                <th className="text-center px-2 py-2.5 w-16">Thru</th>
              </tr>
            </thead>
            <tbody>
              {players.map((p, idx) => (
                <tr key={idx} className={`border-b border-white/5 hover:bg-white/5 transition-colors ${p.position === 1 ? "bg-white/[0.03]" : ""}`} data-testid={`golfer-${p.position}`}>
                  <td className={`px-3 py-2.5 score-font ${p.position === 1 ? "text-[#007AFF] font-bold" : "text-white/50"}`}>{p.position}</td>
                  <td className="px-2 py-2.5">
                    <div className="flex items-center gap-2">
                      {p.flag && <img src={p.flag} alt="" className="w-4 h-4 rounded-full object-contain" />}
                      <span className={`font-semibold truncate ${p.position === 1 ? "text-white" : "text-white/80"}`}>{p.name}</span>
                      {p.winner && <Trophy size={12} weight="fill" className="text-[#34C759]" />}
                    </div>
                  </td>
                  <td className={`text-center px-2 py-2.5 score-font font-bold bg-white/5 ${
                    p.score.startsWith("-") ? "text-[#FF3B30]" : p.score === "E" ? "text-white/60" : "text-white"
                  }`}>{p.score}</td>
                  {p.rounds.map((r, i) => (
                    <td key={i} className="text-center px-2 py-2.5 score-font text-white/50 hidden sm:table-cell">{r}</td>
                  ))}
                  {/* Fill empty rounds */}
                  {p.rounds.length < roundCount && [...Array(roundCount - p.rounds.length)].map((_, i) => (
                    <td key={`e${i}`} className="text-center px-2 py-2.5 text-white/20 hidden sm:table-cell">-</td>
                  ))}
                  <td className="text-center px-2 py-2.5 text-white/40">{p.thru}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
